import React, { useState } from "react";
import { MdClose } from "react-icons/md";
import EmailSetup from "./EmailSetup";

const EmailBox = ({ setAddEmailBox }) => {
  const [error, setError] = useState("");

  // const emailAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?scope=https://mail.google.com/ https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email&include_granted_scopes=true&response_type=token&redirect_uri=http://localhost:3000/integration/email&client_id=417780642135-qoe2gq6ovf43rllsbjrokq67jsfqq0c1.apps.googleusercontent.com`;

  // production URL 

  const emailAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?scope=https://mail.google.com/ https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email&include_granted_scopes=true&response_type=token&redirect_uri=https://www.dashboard.causalfunnels.com/integration/email&client_id=210366452701-hlb77qdv85vefg4q0a1notlhehfdkbln.apps.googleusercontent.com`;

  const handleConnect = (e) => {
    e.preventDefault();
    window.open(emailAuthUrl, "_blank");
  };

  return (
    <div className=" w-full h-full fixed top-0 bg-black/20 z-30 left-0 flex justify-center items-center p-4">
      <div className="bg-white rounded-xl shadow-md p-8 flex flex-col gap-6 items-center justify-center max-w-2xl w-full md:w-[636px] relative">
        <div
          className="absolute -top-4 -right-4 bg-white p-2 rounded-full shadow-sm cursor-pointer"
          onClick={() => {
            setAddEmailBox(false);
          }}
        >
          <MdClose />
        </div>
        <EmailSetup handleConnect={handleConnect} />
        {error && <div className="text-red-500 text-sm my-2">{error}</div>}
      </div>
    </div>
  );
};

export default EmailBox;
